import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { useUIState } from '../../../../app/App';
import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { isMobile } from '../../../../utils/isMobile';

const Component = ({ className }: { className: string }): ReactElement => {
	const { scrollStore } = useUIState();
	return (
		<div
			className={className}
			onClick={scrollStore.scrollToBottom}
			css={css`
				div& {
					opacity: ${scrollStore.showScrollToBottom ? 1 : 0};
					pointer-events: ${scrollStore.showScrollToBottom ? 'auto' : 'none'};
				}
			`}
		>
			<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
				<path d="M38.399,76.8c1.637,0,3.274,0.625,4.524,1.875l85.075,85.076l85.075-85.076c2.5-2.5,6.55-2.5,9.05,0s2.5,6.55,0,9.05  l-89.6,89.601c-2.5,2.5-6.551,2.5-9.051,0l-89.6-89.601c-2.5-2.5-2.5-6.55,0-9.05C35.124,77.425,36.762,76.8,38.399,76.8z" />
			</svg>
		</div>
	);
};

const ScrollToBottomButton = styled(observer(Component))(
	({
		theme: {
			chat: {
				buttons: {
					scrollToBottom: { arrowColorInActive, arrowColorInInactive, size, onHoverBorder, ...other },
				},
			},
		},
	}: {
		theme: Theme;
	}) => {
		return {
			'&:hover': {
				borderColor: !isMobile && onHoverBorder,
				path: {
					fill: !isMobile && arrowColorInActive,
				},
			},
			'&:active': {
				borderColor: onHoverBorder,
				path: {
					fill: arrowColorInActive,
				},
			},
			'& svg': {
				width: size,
				height: size,
				path: {
					fill: arrowColorInInactive,
				},
			},
			...other,
		};
	},
	css`
		position: absolute;
		cursor: pointer;
		transition: opacity 0.2s ease-in-out;
		user-select: none;
	`
);

export { ScrollToBottomButton };
